import React from "react";
import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import ExitCapture from "@/components/marketing/ExitCapture";
import LiveLeadPops from "@/components/marketing/LiveLeadPops";

export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>{children}</main>
      <Footer />
      <ExitCapture />
      <LiveLeadPops />
    </div>
  );
}
